export default class ProvideKey {
    public static readonly GLOBAL_CONFIG = "GLOBAL_CONFIG"
    public static readonly GLOBAL_STORE = "GLOBAL_STORE"
    public static readonly GLOBAL_SESSION = "GLOBAL_SESSION"
    public static readonly GLOBAL_MEASURE = "GLOBAL_MEASURE"
    public static readonly GLOBAL_REPORT = "GLOBAL_REPORT"
    public static readonly LANGUAGE = "LANGUAGE"
}